export default __webpack_public_path__ + "static/media/icon-website-comparison.96ce8694.svg";